import axios from 'axios';

const API_BASE_URL = (import.meta as any).env?.VITE_API_BASE_URL || 'http://localhost:4000/api/v1';

export interface Country {
  value: string;
  label: string;
}

export interface CountryConfig {
  code: string;
  name: string;
  currency: string;
  currencySymbol: string;
  locale: string;
  timezone: string;
  dateFormat: string;
  fiscalYearStart: string;
  fiscalYearEnd: string;
  taxes: Array<{
    name: string;
    rate: number;
    applicableFor: string;
    description: string;
  }>;
}

class CountryService {
  /**
   * Get list of supported countries
   */
  async getSupportedCountries(): Promise<{ success: boolean; data: Country[] }> {
    const response = await axios.get(`${API_BASE_URL}/countries`);
    return response.data;
  }

  /**
   * Get country configuration details
   */
  async getCountryDetails(countryCode: string): Promise<{ success: boolean; data: CountryConfig }> {
    const response = await axios.get(`${API_BASE_URL}/countries/${countryCode}`);
    return response.data;
  }
}

export const countryService = new CountryService();
